import { dispatchStore, getStoreState } from "../store";
import {
  setAddedAction,
  setProductsAction,
  setPriceAction,
  setPurePriceAction,
  setQuantityAction,
  setDiscountAction,
  setPromocodeAction,
  setTotalOldPriceAction,
  setOverallDiscountAction,
  resetPromocodeAction,
} from "../store/cartReducer";
import { setPromocodePopupAction } from "../store/promocodeReducer";

import ProductController from "./productController";
import CartService from "../services/cartService";

import "react-toastify/dist/ReactToastify.css";

export default class CartController {
  static async setCart(added, setStorage = true) {
    if (setStorage) localStorage.setItem("cart", JSON.stringify(added));

    await dispatchStore(setAddedAction(added));
    await this.updateProducts();
  }
  static isItemInCart(itemId) {
    const { cart } = getStoreState();
    const { added } = cart;

    return added.some((item) => item.id === itemId);
  }
  static async addToCart(id, quantity = 1) {
  try {
    const { cart } = getStoreState();
    let added = [...cart.added];
    let found = false;

    for (let item of added) {
      if (item.id === id) {
        item.quantity += quantity;
        found = true;
      }
    }

    if (!found) {
      added.push({ id, quantity });
    }

    await this.setCart(added);
  } catch (error) {
    console.log("Ошибка при добавлении товара в корзину");
  }
}


  static async updateProducts() {
    const { cart } = getStoreState();
    const { added } = cart;
    let products = { ...cart.products };

    let ids = [];

    if (added.length) {
      for (let item of added) {
        const { id } = item;

        if (!products[id]) {
          ids.push(id);
        }
      }

      if (ids.length) {
        const getProducts = await ProductController.getByIds(ids);

        if (getProducts.success) {
          for (let item of getProducts.data.rows) {
            products[item.id] = item;
          }

          await dispatchStore(setProductsAction(products));
        }
      }
    }

    await this.updateCart();
  }
  static async updateCart() {
    const { cart } = getStoreState();
    const { added, products, discount } = cart;

    let totalPrice = 0;
    let totalOldPrice = 0;
    let purePrice = 0;
    let totalQuantity = 0;

    for (let item of added) {
      const product = products[item.id];
      if (!product) continue;

      const basePrice = product.price;
      const oldPrice = product.oldPrice || basePrice;
      const hasProductDiscount = product.isDiscounted;

      const finalPrice = hasProductDiscount
        ? basePrice // ✅ уже со скидкой — не трогаем
        : discount > 0
          ? Math.round(basePrice * (1 - discount / 100)) // ✅ только для несниженных
          : basePrice;

      totalQuantity += item.quantity;
      purePrice += basePrice * item.quantity;
      totalOldPrice += oldPrice * item.quantity;
      totalPrice += finalPrice * item.quantity;
    }

    const overallDiscount =
      totalOldPrice > 0
        ? Math.round(((totalOldPrice - totalPrice) / totalOldPrice) * 100)
        : 0;

    await dispatchStore(setPriceAction(totalPrice));
    await dispatchStore(setPurePriceAction(purePrice));
    await dispatchStore(setTotalOldPriceAction(totalOldPrice));
    await dispatchStore(setOverallDiscountAction(overallDiscount));
    await dispatchStore(setQuantityAction(totalQuantity));
  }

  static async setDiscount(discount) {
    await dispatchStore(setDiscountAction(discount));
    await this.updateCart();
  }

  static async verifyPromocode(promocode) {
    try {
      const { success, message, data } = await CartService.verifyPromocode(
        promocode,
      ).then((res) => res.data);

      return {
        success,
        message,
        data,
      };
    } catch (error) {
      console.log("Ошибка верификации промокода: ", error);
    }
  }
  static async applyPromocode(promocode) {
    try {
      const { success, message, data } = await this.verifyPromocode(promocode);

      if (success) {
        const { cart } = getStoreState();
        const { discount: currentDiscount } = cart;
        const promocodeDiscount = data.discountPercentage;
        let updatedDiscount = currentDiscount + promocodeDiscount;

        await dispatchStore(
          setPromocodeAction({
            name: promocode,
            discountPercentage: data.discountPercentage,
          }),
        );
        await this.setDiscount(updatedDiscount);
      } else {
        console.log(message);
      }
      return { success, message, discountPercentage: data.discountPercentage };
    } catch (error) {
      console.log("Ошибка применения промокода: ", error);
    }
  }
  static async clearCart() {
    await dispatchStore(setAddedAction([]));
    await dispatchStore(setProductsAction({}));
    await dispatchStore(setPriceAction(0));
    await dispatchStore(setPurePriceAction(0));
    await dispatchStore(setQuantityAction(0));
    await dispatchStore(setTotalOldPriceAction(0));
    await dispatchStore(setOverallDiscountAction(0));
    await dispatchStore(resetPromocodeAction());
    await dispatchStore(setPromocodePopupAction(false));

    localStorage.removeItem("cart");
  }
  static async setQuantity(id, quantity) {
    const { cart } = getStoreState();
    let added = [...cart.added];

    added = added.map((item) => {
      if (item.id === id) {
        item.quantity = quantity;
      }

      return item;
    });

    await this.setCart(added);
  }
  static async removeItem(id) {
    const { cart } = getStoreState();
    const added = cart.added.filter((item) => item.id !== id);

    const newProducts = { ...cart.products };
    delete newProducts[id];

    // ✅ Обновляем localStorage
    localStorage.setItem("cart", JSON.stringify(added));

    await dispatchStore(setProductsAction(newProducts));
    await this.setCart(added, false); // ✅ чтобы setCart не опять читал старый localStorage

    if (added.length === 0) {
      await dispatchStore(setDiscountAction(0));
      await dispatchStore(resetPromocodeAction());
    }

    await this.updateCart();
  }

static async send(data) {
  try {
    const res = await CartService.send(data);
    return {
      success: true,
      ...res,
    };
  } catch (e) {
    return {
      success: false,
      message: "Ошибка при отправке данных",
    };
  }
}


  static async userOrders(id) {
    const result = {
      success: false,
      message: "",
    };

    try {
      const data = await CartService.userOrders(id);
      result.success = true;
      result.data = data;
      return result;
    } catch (e) {
      result.message = "Ошибка при отправке данных";
      return result;
    }
  }

  static async getOrder(orderId) {
    const result = {
      success: false,
      message: "",
      data: null,
    };

    try {
      const response = await CartService.getOrder(orderId);
      result.success = true;
      result.data = response.data;
      return result;
    } catch (e) {
      result.message = "Ошибка при получении заказа";
      return result;
    }
  }
}
